/*
 * API Solides
 * \"API de integração com o sistema Solides Gestão. A mesma oferece criação, edição, atualização de registros importantes para sua empresa como: Passaportes, Colaboradores, Ocorrências, Currículos e Vagas.  É obrigatório informar na URL base o parâmetro {locale} cujo os valores possvíeis são: <b>pt-BR</b>, ou <b>es</b>, ou <b>en</b>\"  Para gerar o token de acesso siga os seguintes passos: 1. Acesse https://system.solides.com/pt-BR/usuarios/sign_in e logue com seu usuário. 2. Acesse o sub-menu <b>Configurações</b> 3. Na seção <b>Ativar API de Integração</b>, clique em <b>Ativar API</b>. Isso gerará um token único que deverá ser utilizado em todas as requisições. 4. Configure a Header de sua requisição com essas duas variáveis:     - Content-Type: application/json     - authorization: Token token=<b>[SEU TOKEN]</b> 
 *
 * OpenAPI spec version: 1.0.14
 * Contact: suporte@solides.com.br
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 2.4.13
 *
 * Do not edit the class manually.
 *
 */

(function(factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/Absenteismo', 'model/Beneficio', 'model/Cargos', 'model/Colaborador', 'model/Colaboradores', 'model/Contato', 'model/Curriculos', 'model/Departamento', 'model/Dependente', 'model/Documentos', 'model/Endereco', 'model/EnderecoCity', 'model/EnderecoCityState', 'model/ExisteColaborador', 'model/ExperienciaProfissional', 'model/Ferias', 'model/FormacaoAcademica', 'model/Idioma', 'model/InlineResponse200', 'model/JsonWebservice', 'model/MedicinaESeguranca', 'model/MotivoDeDemissao', 'model/Observacao', 'model/Ocorrencia', 'model/ParametrosDeAbsenteismo', 'model/ParametrosDeAbsenteismoTangerino', 'model/ParametrosDeColaborador', 'model/ParametrosDeCurriculo', 'model/ParametrosDeExperienciaProfissional', 'model/ParametrosDeFormacaoAcademica', 'model/ParametrosDeIdioma', 'model/ParametrosDeOcorrencia', 'model/ParametrosDePassaporte', 'model/ParametrosDeVaga', 'model/ParametrosParaDemitirColaborador', 'model/ParametrosQuestionario', 'model/Passaportes', 'model/Profiler', 'model/Vagas', 'api/AbsentesmosApi', 'api/CargosApi', 'api/ColaboradoresApi', 'api/CurrculosApi', 'api/DepartamentosApi', 'api/MotivoDeDemissesApi', 'api/OcorrnciasApi', 'api/PassaportesApi', 'api/ProfilerApi', 'api/QuestionriosApi', 'api/VagasApi'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('./ApiClient'), require('./model/Absenteismo'), require('./model/Beneficio'), require('./model/Cargos'), require('./model/Colaborador'), require('./model/Colaboradores'), require('./model/Contato'), require('./model/Curriculos'), require('./model/Departamento'), require('./model/Dependente'), require('./model/Documentos'), require('./model/Endereco'), require('./model/EnderecoCity'), require('./model/EnderecoCityState'), require('./model/ExisteColaborador'), require('./model/ExperienciaProfissional'), require('./model/Ferias'), require('./model/FormacaoAcademica'), require('./model/Idioma'), require('./model/InlineResponse200'), require('./model/JsonWebservice'), require('./model/MedicinaESeguranca'), require('./model/MotivoDeDemissao'), require('./model/Observacao'), require('./model/Ocorrencia'), require('./model/ParametrosDeAbsenteismo'), require('./model/ParametrosDeAbsenteismoTangerino'), require('./model/ParametrosDeColaborador'), require('./model/ParametrosDeCurriculo'), require('./model/ParametrosDeExperienciaProfissional'), require('./model/ParametrosDeFormacaoAcademica'), require('./model/ParametrosDeIdioma'), require('./model/ParametrosDeOcorrencia'), require('./model/ParametrosDePassaporte'), require('./model/ParametrosDeVaga'), require('./model/ParametrosParaDemitirColaborador'), require('./model/ParametrosQuestionario'), require('./model/Passaportes'), require('./model/Profiler'), require('./model/Vagas'), require('./api/AbsentesmosApi'), require('./api/CargosApi'), require('./api/ColaboradoresApi'), require('./api/CurrculosApi'), require('./api/DepartamentosApi'), require('./api/MotivoDeDemissesApi'), require('./api/OcorrnciasApi'), require('./api/PassaportesApi'), require('./api/ProfilerApi'), require('./api/QuestionriosApi'), require('./api/VagasApi'));
  }
}(function(ApiClient, Absenteismo, Beneficio, Cargos, Colaborador, Colaboradores, Contato, Curriculos, Departamento, Dependente, Documentos, Endereco, EnderecoCity, EnderecoCityState, ExisteColaborador, ExperienciaProfissional, Ferias, FormacaoAcademica, Idioma, InlineResponse200, JsonWebservice, MedicinaESeguranca, MotivoDeDemissao, Observacao, Ocorrencia, ParametrosDeAbsenteismo, ParametrosDeAbsenteismoTangerino, ParametrosDeColaborador, ParametrosDeCurriculo, ParametrosDeExperienciaProfissional, ParametrosDeFormacaoAcademica, ParametrosDeIdioma, ParametrosDeOcorrencia, ParametrosDePassaporte, ParametrosDeVaga, ParametrosParaDemitirColaborador, ParametrosQuestionario, Passaportes, Profiler, Vagas, AbsentesmosApi, CargosApi, ColaboradoresApi, CurrculosApi, DepartamentosApi, MotivoDeDemissesApi, OcorrnciasApi, PassaportesApi, ProfilerApi, QuestionriosApi, VagasApi) {
  'use strict';

  /**
   * API_de_integrao_com_o_sistema_Solides_Gesto__A_mesma_oferece_criao_edio_atualizao_de_registros_importantes_para_sua_empresa_como_Passaportes_Colaboradores_Ocorrncias_Currculos_e_Vagas__obrigatrio_informar_na_URL_base_o_parmetro_locale_cujo_os_valores_possveis_so_bpt_BRb_ou_besb_ou_benbPara_gerar_o_token_de_acesso_siga_os_seguintes_passos1__Acesse_httpssystem_solides_compt_BRusuariossign_in_e_logue_com_seu_usurio_2__Acesse_o_sub_menu_bConfiguraesb3__Na_seo_bAtivar_API_de_Integraob_clique_em_bAtivar_APIb__Isso_gerar_um_token_nico_que_dever_ser_utilizado_em_todas_as_requisies_4__Configure_a_Header_de_sua_requisio_com_essas_duas_variveis______Content_Type_applicationjson______authorization_Token_tokenb_SEU_TOKENb.<br>
   * The <code>index</code> module provides access to constructors for all the classes which comprise the public API.
   * <p>
   * An AMD (recommended!) or CommonJS application will generally do something equivalent to the following:
   * <pre>
   * var ApiSolides = require('index'); // See note below*.
   * var xxxSvc = new ApiSolides.XxxApi(); // Allocate the API class we're going to use.
   * var yyyModel = new ApiSolides.Yyy(); // Construct a model instance.
   * yyyModel.someProperty = 'someValue';
   * ...
   * var zzz = xxxSvc.doSomething(yyyModel); // Invoke the service.
   * ...
   * </pre>
   * <em>*NOTE: For a top-level AMD script, use require(['index'], function(){...})
   * and put the application logic within the callback function.</em>
   * </p>
   * <p>
   * A non-AMD browser application (discouraged) might do something like this:
   * <pre>
   * var xxxSvc = new ApiSolides.XxxApi(); // Allocate the API class we're going to use.
   * var yyy = new ApiSolides.Yyy(); // Construct a model instance.
   * yyyModel.someProperty = 'someValue';
   * ...
   * var zzz = xxxSvc.doSomething(yyyModel); // Invoke the service.
   * ...
   * </pre>
   * </p>
   * @module index
   * @version 1.0.14
   */
  var exports = {
    /**
     * The ApiClient constructor.
     * @property {module:ApiClient}
     */
    ApiClient: ApiClient,
    /**
     * The Absenteismo model constructor.
     * @property {module:model/Absenteismo}
     */
    Absenteismo: Absenteismo,
    /**
     * The Beneficio model constructor.
     * @property {module:model/Beneficio}
     */
    Beneficio: Beneficio,
    /**
     * The Cargos model constructor.
     * @property {module:model/Cargos}
     */
    Cargos: Cargos,
    /**
     * The Colaborador model constructor.
     * @property {module:model/Colaborador}
     */
    Colaborador: Colaborador,
    /**
     * The Colaboradores model constructor.
     * @property {module:model/Colaboradores}
     */
    Colaboradores: Colaboradores,
    /**
     * The Contato model constructor.
     * @property {module:model/Contato}
     */
    Contato: Contato,
    /**
     * The Curriculos model constructor.
     * @property {module:model/Curriculos}
     */
    Curriculos: Curriculos,
    /**
     * The Departamento model constructor.
     * @property {module:model/Departamento}
     */
    Departamento: Departamento,
    /**
     * The Dependente model constructor.
     * @property {module:model/Dependente}
     */
    Dependente: Dependente,
    /**
     * The Documentos model constructor.
     * @property {module:model/Documentos}
     */
    Documentos: Documentos,
    /**
     * The Endereco model constructor.
     * @property {module:model/Endereco}
     */
    Endereco: Endereco,
    /**
     * The EnderecoCity model constructor.
     * @property {module:model/EnderecoCity}
     */
    EnderecoCity: EnderecoCity,
    /**
     * The EnderecoCityState model constructor.
     * @property {module:model/EnderecoCityState}
     */
    EnderecoCityState: EnderecoCityState,
    /**
     * The ExisteColaborador model constructor.
     * @property {module:model/ExisteColaborador}
     */
    ExisteColaborador: ExisteColaborador,
    /**
     * The ExperienciaProfissional model constructor.
     * @property {module:model/ExperienciaProfissional}
     */
    ExperienciaProfissional: ExperienciaProfissional,
    /**
     * The Ferias model constructor.
     * @property {module:model/Ferias}
     */
    Ferias: Ferias,
    /**
     * The FormacaoAcademica model constructor.
     * @property {module:model/FormacaoAcademica}
     */
    FormacaoAcademica: FormacaoAcademica,
    /**
     * The Idioma model constructor.
     * @property {module:model/Idioma}
     */
    Idioma: Idioma,
    /**
     * The InlineResponse200 model constructor.
     * @property {module:model/InlineResponse200}
     */
    InlineResponse200: InlineResponse200,
    /**
     * The JsonWebservice model constructor.
     * @property {module:model/JsonWebservice}
     */
    JsonWebservice: JsonWebservice,
    /**
     * The MedicinaESeguranca model constructor.
     * @property {module:model/MedicinaESeguranca}
     */
    MedicinaESeguranca: MedicinaESeguranca,
    /**
     * The MotivoDeDemissao model constructor.
     * @property {module:model/MotivoDeDemissao}
     */
    MotivoDeDemissao: MotivoDeDemissao,
    /**
     * The Observacao model constructor.
     * @property {module:model/Observacao}
     */
    Observacao: Observacao,
    /**
     * The Ocorrencia model constructor.
     * @property {module:model/Ocorrencia}
     */
    Ocorrencia: Ocorrencia,
    /**
     * The ParametrosDeAbsenteismo model constructor.
     * @property {module:model/ParametrosDeAbsenteismo}
     */
    ParametrosDeAbsenteismo: ParametrosDeAbsenteismo,
    /**
     * The ParametrosDeAbsenteismoTangerino model constructor.
     * @property {module:model/ParametrosDeAbsenteismoTangerino}
     */
    ParametrosDeAbsenteismoTangerino: ParametrosDeAbsenteismoTangerino,
    /**
     * The ParametrosDeColaborador model constructor.
     * @property {module:model/ParametrosDeColaborador}
     */
    ParametrosDeColaborador: ParametrosDeColaborador,
    /**
     * The ParametrosDeCurriculo model constructor.
     * @property {module:model/ParametrosDeCurriculo}
     */
    ParametrosDeCurriculo: ParametrosDeCurriculo,
    /**
     * The ParametrosDeExperienciaProfissional model constructor.
     * @property {module:model/ParametrosDeExperienciaProfissional}
     */
    ParametrosDeExperienciaProfissional: ParametrosDeExperienciaProfissional,
    /**
     * The ParametrosDeFormacaoAcademica model constructor.
     * @property {module:model/ParametrosDeFormacaoAcademica}
     */
    ParametrosDeFormacaoAcademica: ParametrosDeFormacaoAcademica,
    /**
     * The ParametrosDeIdioma model constructor.
     * @property {module:model/ParametrosDeIdioma}
     */
    ParametrosDeIdioma: ParametrosDeIdioma,
    /**
     * The ParametrosDeOcorrencia model constructor.
     * @property {module:model/ParametrosDeOcorrencia}
     */
    ParametrosDeOcorrencia: ParametrosDeOcorrencia,
    /**
     * The ParametrosDePassaporte model constructor.
     * @property {module:model/ParametrosDePassaporte}
     */
    ParametrosDePassaporte: ParametrosDePassaporte,
    /**
     * The ParametrosDeVaga model constructor.
     * @property {module:model/ParametrosDeVaga}
     */
    ParametrosDeVaga: ParametrosDeVaga,
    /**
     * The ParametrosParaDemitirColaborador model constructor.
     * @property {module:model/ParametrosParaDemitirColaborador}
     */
    ParametrosParaDemitirColaborador: ParametrosParaDemitirColaborador,
    /**
     * The ParametrosQuestionario model constructor.
     * @property {module:model/ParametrosQuestionario}
     */
    ParametrosQuestionario: ParametrosQuestionario,
    /**
     * The Passaportes model constructor.
     * @property {module:model/Passaportes}
     */
    Passaportes: Passaportes,
    /**
     * The Profiler model constructor.
     * @property {module:model/Profiler}
     */
    Profiler: Profiler,
    /**
     * The Vagas model constructor.
     * @property {module:model/Vagas}
     */
    Vagas: Vagas,
    /**
     * The AbsentesmosApi service constructor.
     * @property {module:api/AbsentesmosApi}
     */
    AbsentesmosApi: AbsentesmosApi,
    /**
     * The CargosApi service constructor.
     * @property {module:api/CargosApi}
     */
    CargosApi: CargosApi,
    /**
     * The ColaboradoresApi service constructor.
     * @property {module:api/ColaboradoresApi}
     */
    ColaboradoresApi: ColaboradoresApi,
    /**
     * The CurrculosApi service constructor.
     * @property {module:api/CurrculosApi}
     */
    CurrculosApi: CurrculosApi,
    /**
     * The DepartamentosApi service constructor.
     * @property {module:api/DepartamentosApi}
     */
    DepartamentosApi: DepartamentosApi,
    /**
     * The MotivoDeDemissesApi service constructor.
     * @property {module:api/MotivoDeDemissesApi}
     */
    MotivoDeDemissesApi: MotivoDeDemissesApi,
    /**
     * The OcorrnciasApi service constructor.
     * @property {module:api/OcorrnciasApi}
     */
    OcorrnciasApi: OcorrnciasApi,
    /**
     * The PassaportesApi service constructor.
     * @property {module:api/PassaportesApi}
     */
    PassaportesApi: PassaportesApi,
    /**
     * The ProfilerApi service constructor.
     * @property {module:api/ProfilerApi}
     */
    ProfilerApi: ProfilerApi,
    /**
     * The QuestionriosApi service constructor.
     * @property {module:api/QuestionriosApi}
     */
    QuestionriosApi: QuestionriosApi,
    /**
     * The VagasApi service constructor.
     * @property {module:api/VagasApi}
     */
    VagasApi: VagasApi
  };

  return exports;
}));
